import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import * as angular from "angular";
import { BaseContractController } from "../_baseDealController";
import { ContractService } from "../../services/contract-service";
import { EntityService } from "../../services/entity-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AdminService } from "../../services/admin-service";
import { AclService } from "../../services/acl-service";
import { ModalService } from "../../services/modal-service";

export class ContractRoyaltiesController extends BaseContractController {
    static $inject = ["$scope", "$rootScope", "$q", "$location", "$anchorScroll", "$window", "contractService", "entityService",
        "entityConfigService", "contractSharedDataService", "localCacheService", "notifyService", "eventService", "adminService",
        "$interval", "aclService", "modalService"];

    contractID: string;
    editModes: { [key: string]: boolean };
    openRoyaltiesPanel: { [key: string]: boolean } = {};
    initialized: boolean;
    locked: boolean;

    royaltyAssets: { [royaltyRelRecID: string]: Models.IEntityRelationshipPair[] };
    contractRoyalties: Models.IContractRoyaltyRelationshipPair[];
    royaltyHeaders: Models.IRoyaltyHeader[];
    royaltyTemplates: Models.ICharacteristicTemplate[];
    contractPayees: Models.IEntity[];
    contractIncomeGroups: Models.ICharacteristicMetaDataValue[];

    newRoyaltyModalOpen: boolean;
    newRoyaltyTemplate: Models.ICharacteristicTemplate;
    newRoyaltyCharData: Models.ICharDataCollection;
    newRoyaltySplits: Models.IRoyaltySplit[];
    newRoyaltyPayees: Models.IEntity[];
    newRoyaltyIncomeGroups: Models.ICharacteristicMetaDataValue[];
    newRoyaltyAssets: Models.IEntitySearchDoc[];

    availAssetDictionary: { [key: number]: Models.IEntitySearchDoc[] };
    royaltyIncomeGroupDictionary: { [key: number]: Models.ICharacteristicMetaDataValue[] };
    royaltyAssocAssetModalOpen: boolean;
    royaltyAssocAssetModalTitle: string;
    royaltyAssocRoyalty: Models.IContractRoyaltyRelationshipPair;
    royaltyAssocCheckAll: boolean;
    royaltyAssocSelectedAssetIDs: string[];

    canEdit: boolean;
    open: boolean;
    canCopy: boolean;

    constructor($scope: ng.IScope,
        $rootScope: ng.IRootScopeService,
        $q: ng.IQService,
        public $location: ng.ILocationService,
        public $anchorScroll: ng.IAnchorScrollService,
        private $window: ng.IWindowService,
        private contractService: ContractService,
        entityService: EntityService,
        private entityConfigService: EntityConfigService,
        sharedData: ContractSharedDataService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        private eventService: EventService,
        adminService: AdminService,
        $interval: ng.IIntervalService,
        private aclService: AclService,
        private modalService: ModalService
    ) {

        super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

        this.contractID = "";
        //this.editModes = {};
        this.initialized = false;
        this.locked = false;

        this.contractRoyalties = [];
        this.royaltyHeaders = [];
        this.royaltyTemplates = [];
        this.contractPayees = [];
        this.contractIncomeGroups = [];

        this.newRoyaltyModalOpen = false;
        this.newRoyaltyTemplate = null;
        this.newRoyaltyCharData = null;
        this.newRoyaltySplits = [];
        this.newRoyaltyPayees = [];
        this.newRoyaltyIncomeGroups = [];
        this.newRoyaltyAssets = [];

        this.availAssetDictionary = {};
        this.royaltyIncomeGroupDictionary = {};
        this.royaltyAssocAssetModalOpen = false;
        this.royaltyAssocAssetModalTitle = "";
        this.royaltyAssocRoyalty = null;
        this.royaltyAssocCheckAll = false;
        this.royaltyAssocSelectedAssetIDs = [];

        this.canEdit = false;
        this.open = true;
        this.canCopy = false;

        $scope.$watch(() => this.entity,
            (newValue, oldValue) => {
                if ((newValue !== oldValue) || (this.entity == null)) {
                    if (!this.wasValidated) {
                        this.Validate();
                    }
                }
            });

        $scope.$watchCollection(() => [this.sharedData.contractAssets, this.contractRoyalties], (newValue, oldValue) => {
            if (newValue[0] && newValue[1]) {
                var contractsAssets = (<Models.AdvancedSearchResult>newValue[0]).documents;
                var contractRoyalties = <Models.IContractRoyaltyRelationshipPair[]>newValue[1];

                this.availAssetDictionary = {};
                if (contractsAssets != null && contractRoyalties != null) {
                    _.forEach(contractRoyalties, (royalty) => {
                        var availAssets: Models.IEntitySearchDoc[] = [];
                        _.forEach(contractsAssets, (asset) => {
                            if (!_.any(royalty.assets, (childAsset) => childAsset.record.recordID == asset.recordID)) {
                                availAssets.push(asset);
                            }
                        });


                        this.availAssetDictionary[royalty.record.recordID] = availAssets;

                    });
                }
            }
        });

        $rootScope.$on(Consts.Events.RoyaltySplitsChanged, (event, royaltySetID: string, removedIncomeGroups: Models.ICharacteristicMetaDataValue[]) => {
            // an income group at the royalty set level was removed, causing an update to the underlying splits
            var contractRoyalty = _.find(this.contractRoyalties, cr => cr.relationship.childRecID == Utils.IdBuilder.splitEntityID(royaltySetID).recID);
            if (contractRoyalty) {
                var splitsRemoved = _.remove(contractRoyalty.royaltySplits, (sp) => _.any(removedIncomeGroups, ig => ig.characteristicValueID == sp.incomeGroupID));
                this.Save(contractRoyalty, true, false);
            }
        });

        //replace with event watch
        this.eventService.on(Consts.Events.ContactsRefreshed, () => {
            this.RefreshPayees();
        });
        $scope.$watch(() => this.newRoyaltyCharData,
            (newValue, oldValue) => {
                if (newValue != null && newValue != oldValue && newValue.charDatas) {
                    var referenceCharCMD = _.find(newValue.templateMetaData.characteristicMetaDatas, function (cmd) { return cmd.systemIndicator == Consts.SystemIndicators.RoyaltyIncomeGroup; });
                    var refIncomeGroups: Models.ICharacteristicMetaDataValue[] = [];
                    if (!_.isUndefined(referenceCharCMD)) {
                        var referenceChar = newValue.charDatas[referenceCharCMD.tagLabel];
                        refIncomeGroups = _.map<Models.ICharDataValue, Models.ICharacteristicMetaDataValue>(referenceChar, (charDataVal) => {
                            var ig: Models.ICharacteristicMetaDataValue = {
                                characteristicValueID: charDataVal.valueID,
                                characteristicValueLabel: charDataVal.value,
                                childValues: null,
                                defaultIndicator: 0,
                                sequenceNumber: charDataVal.charID
                            };
                            return ig;
                        });
                        this.newRoyaltyIncomeGroups = refIncomeGroups;
                    }
                }
            }, true);
        $scope.$watch(() => this.newRoyaltyModalOpen,
            (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    this.newRoyaltyCharData = null;
                    this.newRoyaltyTemplate = null;
                    this.newRoyaltySplits = [];
                    this.newRoyaltyPayees = [];
                    this.newRoyaltyIncomeGroups = [];
                }
            });

        /* reset values whenver royaltyAssocAssetModal closes */
        $scope.$watch<boolean>(() => this.royaltyAssocAssetModalOpen,
            (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    this.royaltyAssocAssetModalTitle = "";
                    this.royaltyAssocRoyalty = null;
                    this.royaltyAssocCheckAll = false;
                }
            });

        /* set checkbox status on asset assoc list */
        $scope.$watch<boolean>(() => this.royaltyAssocCheckAll,
            (newValue, oldValue) => {
                if (newValue && this.royaltyAssocRoyalty != null) {
                    this.royaltyAssocSelectedAssetIDs = this.availAssetDictionary[this.royaltyAssocRoyalty.record.recordID].map((asset) => asset.entityID);
                } else {
                    this.royaltyAssocSelectedAssetIDs = [];
                }
            });

        eventService.on(Consts.Events.ContractRefreshAll, () => {
            return this.RefreshAll();
        });
    }

    private canDeleteResults: _.Dictionary<boolean> = {};
    private canEditResults: _.Dictionary<boolean> = {};

    Init(contractID: string) {
        this.contractID = contractID;
        this.RefreshAll();
        this.aclService.loadActivityAcls()
            .then((acls) => {
                this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod4.Royalties);
                this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
            });
    }

    RefreshAll(): ng.IPromise<any> {
        var recID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
        this.notifyService.startProgress();

        var promise1 = this.RefreshRoyalties();

        var promise2 = this.sharedData.RefreshContractStatus(this.contractID)
            .then((result) => {
                this.locked = result.lockIndicator > 0;
            });

        var promise3 = this.sharedData.RefreshContract(this.contractID)
            .then((result) => {
                return this.entityService.getAssociatedTemplatesForTemplate(result.record.charTypeID, result.record.templateID, Consts.CharTypeIDs.royalty)
                    .then((result2) => {
                        this.entity = result.record;
                        this.royaltyTemplates = result2.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
                    });
            });

        var promise4 = this.sharedData.RefreshAssets(this.contractID);

        var promise5 = this.RefreshPayees();

        var promise6 = this.contractService.getContractRoyaltyIncomeGroups()
            .then((results) => {
                this.newRoyaltyIncomeGroups = results;
                this.contractIncomeGroups = results;
            });

        return this.$q.all([promise1, promise2, promise3, promise4, promise5, promise6])
            .then(() => {
                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });

    }

    private getRoyaltyEntity(entityID: string) {
        return this.entityService.getEntityCharData(entityID);
    }

    EditRoyalty(royalty: Models.IContractRoyaltyRelationshipPair) {
        this.getRoyaltyEntity(royalty.record.id)
            .then((res) => {
                return this.modalService.editEntityWithRelationships(res,
                    this.contractID,
                    null,
                    royalty.assets.map((a) => { return a.relationship }),
                    Utils.IdBuilder.buildRelationshipID(royalty.relationship),
                    [Consts.CharTypeIDs.property])
                    .then(() => {
                        this.RefreshRoyalty(royalty.relationship.relRecID);
                        this.sharedData.RefreshContract(this.contractID);
                    });
            });
    }

    RefreshPayees(): ng.IPromise<any> {
        var recID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
        this.notifyService.startProgress();
        return this.contractService.getContractRoyaltyPayees(recID)
            .then((results) => {
                this.newRoyaltyPayees = results;
                this.contractPayees = results;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }
    CancelModal() {
        this.newRoyaltyModalOpen = false;
    }

    Cancel(royalty: Models.IContractRoyaltyRelationshipPair) {
        this.notifyService.startProgress();
        this.RefreshRoyalty(royalty.relationship.relRecID)
            .then(() => {
                this.editModes[royalty.record.id] = false;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    setIncomeGroups(royalty: Models.IContractRoyaltyRelationshipPair) {
        //if the royalty set defines an income group override, use that insted of the contractIncomeGroups
        var referenceCharCMD = _.find(royalty.charDataCollection.templateMetaData.characteristicMetaDatas, function (cmd) { return cmd.systemIndicator == Consts.SystemIndicators.RoyaltyIncomeGroup; });
        var refIncomeGroups: Models.ICharacteristicMetaDataValue[] = [];
        if (!_.isUndefined(referenceCharCMD)) {
            var referenceChar = royalty.charDataCollection.charDatas[referenceCharCMD.tagLabel];
            refIncomeGroups = _.map<Models.ICharDataValue, Models.ICharacteristicMetaDataValue>(referenceChar, (charDataVal) => {
                var ig: Models.ICharacteristicMetaDataValue = {
                    characteristicValueID: charDataVal.valueID,
                    characteristicValueLabel: charDataVal.value,
                    childValues: null,
                    defaultIndicator: 0,
                    sequenceNumber: charDataVal.charID
                };
                return ig;
            });
        }
        else {
            refIncomeGroups = this.contractIncomeGroups;
        }
        this.royaltyIncomeGroupDictionary[royalty.record.recordID] = refIncomeGroups;
    }

    RefreshRoyalties() {
        var recID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
        this.notifyService.startProgress();
        return this.contractService.getContractRoyalties(recID)
            .then((result) => {
                this.contractRoyalties = result;
                this.getTableHeaders();
                _.forEach(this.contractRoyalties, (royalty) => {
                    this.setIncomeGroups(royalty);
                });

            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    getTableHeaders() {
        let distinctTemplateIds = this.contractRoyalties
            .map(x => x.charDataCollection.templateMetaData.templateID);

        const headers: Models.IRoyaltyHeader[] = [];

        for (let i = 0; i < this.contractRoyalties.length; i++) {
            const templateMetaData = this.contractRoyalties[i].charDataCollection.templateMetaData;
            if (distinctTemplateIds.indexOf(templateMetaData.templateID) >= 0) {
                distinctTemplateIds = distinctTemplateIds.filter(x => x !== templateMetaData.templateID);

                const templateHeaders = Utils.AclUtil.filterCMDsByRights(this.aclService.acls, templateMetaData, Consts.AccessRight.Read);

                templateHeaders.forEach(x => {
                    if (headers.map(y => y.label).indexOf(x.label) < 0) {
                        headers.push({ label: x.label, tagLabel: x.tagLabel });
                    }
                });
            }
        }

        this.royaltyHeaders = headers;
    }

    GetCmd(tagLabel: string, royalty: Models.IContractRoyaltyRelationshipPair) {
        const cmd = royalty.charDataCollection.templateMetaData.characteristicMetaDatas
            .filter(x => x.tagLabel === tagLabel);

        return cmd.length > 0 ? cmd[0] : null;
    }

    RefreshRoyalty(relRecID: number) {
        var recID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
        return this.contractService.getContractRoyalties(recID, relRecID)
            .then(result => {
                if (result.length == 1) {
                    var index = _.findIndex<Models.IContractRoyaltyRelationshipPair>(this.contractRoyalties, (royalty) => royalty.relationship.relRecID == relRecID);
                    if (index > -1) {
                        this.contractRoyalties[index] = result[0];
                        this.setIncomeGroups(result[0]);
                    }

                }
            });

    }

    RemoveRoyalty(royalty: Models.IContractRoyaltyRelationshipPair) {
        if (this.$window.confirm("Are you sure you want to delete this royalty set?")) {
            this.notifyService.startProgress();
            this.contractService.deleteRoyalty(royalty.record.recordID)
                .then(() => {
                    this.notifyService.notifySuccess("Royalty Set Deleted");
                    this.sharedData.RefreshContract(this.contractID);
                    return this.RefreshRoyalties();
                }, () => {
                    this.notifyService.notifyError("Error deleting Royalty Set");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });

        } else {
            this.notifyService.broadcastDone();
        }
    }

    Save(royalty: Models.IContractRoyaltyRelationshipPair, isValid: boolean, showNotification: boolean = true) {
        if (isValid) {
            this.notifyService.startProgress();
            this.contractService.saveRoyalty(royalty.record.id, royalty.charDataCollection.charDatas, royalty.relationship.relRecID, royalty.royaltySplits)
                .then(() => {
                    this.editModes[royalty.record.id] = false;
                    return this.RefreshRoyalty(royalty.relationship.relRecID);
                },
                () => {
                    if (showNotification) {
                        this.notifyService.notifyError("Error saving Royalty Set");
                    }
                    })
                .then(() => {
                    if (showNotification) {
                        this.notifyService.notifySuccess("Save Successful");
                    }
                    this.RefreshValidation();
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    NewRoyalty(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
        $event.preventDefault();

        this.newRoyaltyTemplate = template;

        var divID = Utils.IdBuilder.splitEntityID(this.contractID).divID;

        var templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.royalty, template.templateID);
        this.notifyService.startProgress();
        this.entityService.getEmptyEntityCharData(templateID)
            .then((result) => {
                //what abuot new royalty 
                this.newRoyaltyCharData = result;
                this.newRoyaltyModalOpen = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    CreateRoyalty(isValid: boolean) {
        if (isValid) {
            var transRecID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
            var templateID = this.newRoyaltyTemplate.templateID;
            var charDatas = this.newRoyaltyCharData.charDatas;
            var splits = this.newRoyaltySplits;
            var assetRecIDs = this.newRoyaltyAssets.map((asset) => asset.recordID);

            this.notifyService.startProgress();
            this.contractService.createRoyalty(transRecID, templateID, charDatas, assetRecIDs, splits)
                .then(() => {
                    this.notifyService.notifySuccess("Royalty Created");
                    this.newRoyaltyTemplate = null;
                    this.sharedData.RefreshContract(this.contractID);
                    return this.RefreshRoyalties();
                },
                    () => {
                        this.notifyService.notifyError("Error creating Royalty");
                        return this.$q.reject();
                    })
                .then(() => {
                    this.newRoyaltyModalOpen = false;
                }, angular.noop)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    RefreshValidation() {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
            this.notifyService.startProgress();
            this.contractService.deleteContract(this.contractID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ContractListPage);
                },
                    () => {
                        this.notifyService.notifyError("Error Deleting Deal");
                    })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.notifyService.broadcastDone();
        }
    }

    CopySuccessful(newEntityID: string) {
        this.RefreshRoyalties();
    }

    CanDelete(royalty: Models.IContractRoyaltyRelationshipPair) {
        if (royalty != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.royalty, royalty.record.templateGroupID, royalty.record.templateID);
            if (this.canDeleteResults[acl] == null) {
                this.canDeleteResults[acl] = Utils.AclUtil.hasDeleteAccess(this.aclService.acls, acl);
            }
            return this.canDeleteResults[acl];
        }
    }

    CanEdit(royalty: Models.IContractRoyaltyRelationshipPair) {
        if (royalty != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.royalty, royalty.record.templateGroupID, royalty.record.templateID);
            if (this.canEditResults[acl] == null) {
                this.canEditResults[acl] = Utils.AclUtil.hasWriteAccess(this.aclService.acls, acl);
            }
            return this.canEditResults[acl];
        }
    }
}
